<template>
  <div id="report-body-view">
    <report-list/>
    <report-pagination/>
  </div>
</template>

<script>
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import ReportList from "./components/ReportList";
import ReportPagination from "./components/ReportPagination";

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  components: {
    ReportList,
    ReportPagination
  },
  methods: {

  },
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#report-body-view {
  --vs-primary: 3, 155, 229;
}
</style>
